import React, { useState } from "react";
import "./Nav.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBagShopping, faUser } from "@fortawesome/free-solid-svg-icons";
import Oeil from "../layout/Oeil";
import { useAuth } from "../Context/AuthContext";
import { usePanier } from "../../PanierContext";

interface NavProps {
  onOpenCart: () => void;
  onOpenAccount: () => void;
}

const Nav: React.FC<NavProps> = ({ onOpenCart, onOpenAccount }) => {
  const { user } = useAuth();
  const { panier } = usePanier();

  const totalItems = panier.reduce((acc, el) => acc + el.nombre, 0);

  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className="nav">
      <div className="nav__inner">
        {/* Logo / Oeil animé */}
        <button className="nav__logo" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} aria-label="Retour en haut">
          <Oeil />
        </button>

        {/* Titre central */}
        <button className="nav__brand" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
          Celeste Favaro
        </button>

        {/* Actions droite */}
        <div className="nav__actions">
          <nav className="nav__links" aria-label="Navigation principale">
            <button onClick={() => scrollToSection("boutique")}>Boutique</button>
            <button onClick={() => scrollToSection("contact")}>Contact</button>
          </nav>

          <button
            className="nav__icon-btn"
            onClick={onOpenAccount}
            aria-label={user ? "Mon compte" : "Connexion"}
            title={user ? `Connecté : ${user.email}` : "Se connecter"}
          >
            <FontAwesomeIcon icon={faUser} />
            {user && <span className="nav__user-dot" />}
          </button>

          <button
            className="nav__icon-btn nav__cart-btn"
            onClick={onOpenCart}
            aria-label="Panier"
          >
            <FontAwesomeIcon icon={faBagShopping} />
            {totalItems > 0 && (
              <span className="nav__badge">{totalItems}</span>
            )}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Nav;
